var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgScheduleCardExampleAnimationMedicalRecord = function SvgScheduleCardExampleAnimationMedicalRecord(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 121.522,
    viewBox: "0 0 332 121.522",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5906",
    "data-name": "Grupo 5906",
    transform: "translate(-517 -110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5259",
    "data-name": "Grupo 5259",
    transform: "translate(503 -73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_195",
    "data-name": "Grupo 195",
    transform: "translate(14 183)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_447",
    "data-name": "Ret\\xE2ngulo 447",
    width: 332,
    height: 113,
    rx: 10,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_833",
    "data-name": "Grupo 833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_385",
    "data-name": "Grupo 385",
    transform: "translate(24 193)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_447-2",
    "data-name": "Ret\\xE2ngulo 447",
    width: 75,
    height: 93,
    rx: 10,
    transform: "translate(0)",
    fill: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_10h",
    "data-name": "10h",
    transform: "translate(62 225)",
    fill: "#c1c1c1",
    fontSize: 24,
    fontFamily: "Ubuntu",
    fontWeight: 700,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19,
    y: 0
  }, "10h")), /*#__PURE__*/React.createElement("text", {
    id: "realizada",
    transform: "translate(62 274)",
    fill: "#4ac326",
    fontSize: 12,
    fontFamily: "Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26,
    y: 0
  }, "realizada")), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_2",
    "data-name": "Subtra\\xE7\\xE3o 2",
    d: "M-82-1644a10.011,10.011,0,0,1-10-10,10.011,10.011,0,0,1,10-10,10.011,10.011,0,0,1,10,10,9.94,9.94,0,0,1-2.93,7.069A9.941,9.941,0,0,1-82-1644Zm-4.154-10.949-1.157,1.336,4.362,3.768,6.2-7.151-1.335-1.157-5.045,5.816-3.027-2.611Z",
    transform: "translate(144 1905)",
    fill: "#4ac326"
  })), /*#__PURE__*/React.createElement("text", {
    id: "ID_1234",
    "data-name": "ID 1234",
    transform: "translate(114 279)",
    fill: "#898989",
    fontSize: 12,
    fontFamily: "Ubuntu-Regular, Ubuntu"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ID 1234")), /*#__PURE__*/React.createElement("text", {
    id: "_2_consulta_com_T\\xE1ssio_Oliveira_dos_Santos",
    "data-name": "2\\xAA consulta com T\\xE1ssio Oliveira dos  Santos",
    transform: "translate(114 212)",
    fill: "#898989",
    fontSize: 15,
    fontFamily: "Ubuntu"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2\xAA consulta com"), /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16
  }, "T\xE1ssio Oliveira dos "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 32
  }, "Santos")))), /*#__PURE__*/React.createElement("g", {
    id: "icon_busca",
    "data-name": "icon busca",
    transform: "translate(802 149)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_542",
    "data-name": "Ret\\xE2ngulo 542",
    width: 35,
    height: 35,
    rx: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_388",
    "data-name": "Grupo 388",
    transform: "translate(5.912 5.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2225",
    "data-name": "Caminho 2225",
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22.154A10.154,10.154,0,1,1,22.154,12,10.152,10.152,0,0,1,12,22.154Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_50",
    "data-name": "Elipse 50",
    cx: 1.655,
    cy: 1.655,
    r: 1.655,
    transform: "translate(5.289 10.345)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_51",
    "data-name": "Elipse 51",
    cx: 1.655,
    cy: 1.655,
    r: 1.655,
    transform: "translate(10.345 10.345)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_52",
    "data-name": "Elipse 52",
    cx: 1.655,
    cy: 1.655,
    r: 1.655,
    transform: "translate(15.4 10.345)",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_60",
    "data-name": "Elipse 60",
    transform: "translate(23 2)",
    fill: "#fd4949",
    stroke: "#f5f5f5",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 6.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_61",
    "data-name": "Elipse 61",
    transform: "translate(790 136)",
    fill: "none",
    stroke: "#fd4949",
    strokeWidth: 2,
    strokeDasharray: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 28.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linha_171",
    "data-name": "Linha 171",
    y1: 37,
    x2: 22,
    transform: "translate(783.5 193.5)",
    fill: "none",
    stroke: "#fd4949",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_3",
    "data-name": "Pol\\xEDgono 3",
    d: "M7,0l7,11H0Z",
    transform: "translate(803.688 183.237) rotate(30)",
    fill: "#fd4949"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScheduleCardExampleAnimationMedicalRecord, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/schedule-card-example-animation-medical-record.56b66dc6.svg";
export { ForwardRef as ReactComponent };